import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as thunk from './thunk';

export const initialState = {
    projectList:[],
    dataList: [],
    error: {},
    loading: true
};

const ProjectSlice = createSlice({
    name: 'Projects',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(thunk.getAll.fulfilled, (state, action) => {
            state.dataList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getAll.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        // <--------------------------- getProject --------------------------->
        builder.addCase(thunk.getProject.fulfilled, (state, action) => {
            state.projectList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getProject.rejected, (state, action) => {
            state.error = action?.error || {};
        });
        
        builder.addCase(thunk.create.fulfilled, (state, action) => {
            state.dataList.unshift(action.payload);
        });
        builder.addCase(thunk.create.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        builder.addCase(thunk.update.fulfilled, (state, action) => {
            const id = action?.payload.id;
            if (_.isEmpty(id)) {
                return;
            }

            const dataList = (state.dataList || []).filter(x => x.id !== id);
            dataList.unshift(action.payload);
            state.dataList = dataList;
        });

        builder.addCase(thunk.update.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });

        builder.addCase(thunk.remove.fulfilled, (state, action) => {
            state.dataList = state.dataList.filter(x => x.id !== action.payload);
        });
        builder.addCase(thunk.remove.rejected, (state, action) => {
            state.error = action?.payload?.error || null;
        });
    }
});

export default ProjectSlice.reducer;
